// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Chevron__chevron___Z6_w3 {
    margin-left: 10px;
    position: relative;
    top: 2px;
    color: gray;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chevron": `Chevron__chevron___Z6_w3`
};
module.exports = ___CSS_LOADER_EXPORT___;
